import { GridViewSvg, ListViewSvg, TableViewSvg } from '../svgs/index';
import { ViewMode } from '../../types/enums/viewMode.enum';
import './toggleView.scss';

type ToggleViewProps = {
  value: ViewMode;
  onChange: (viewMode: ViewMode) => void;
};

const toggleOptions = [
  { type: ViewMode.Card, title: 'Card View', Icon: GridViewSvg },
  { type: ViewMode.List, title: 'List View', Icon: ListViewSvg },
  { type: ViewMode.Table, title: 'Table View', Icon: TableViewSvg },
];

const ToggleView = ({ value, onChange }: ToggleViewProps) => {
  return (
    <div className="toggle-view">
      {toggleOptions.map(option => {
        const Icon = option.Icon;
        return (
          <button
            key={option.type}
            type="button"
            className={`toggle-view-btn ${value === option.type ? 'active' : ''}`}
            onClick={() => onChange(option.type)}
            title={option.title}>
            <Icon />
          </button>
        );
      })}
    </div>
  );
};

export default ToggleView;
